exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ":host {\n  position: absolute;\n  display: block;\n  width: 100%;\n  height: 100%;\n  background-color: #2D2C2F;\n  top: 0;\n  left: 0;\n  z-index: 9;\n  color: white; }\n  :host .info {\n    margin: 40px 20px;\n    font-size: 14px; }\n  :host .payin-input {\n    width: calc(100% - 60px);\n    padding: 15px;\n    margin-left: 15px;\n    background-color: white;\n    color: black;\n    font-size: 14px; }\n  :host .button {\n    position: absolute;\n    bottom: 0;\n    left: 30%;\n    margin-top: 5px;\n    width: 70%;\n    height: 60px;\n    display: -ms-flexbox;\n    display: flex;\n    -ms-flex-align: center;\n        align-items: center;\n    -ms-flex-pack: center;\n        justify-content: center;\n    font-size: 16px; }\n    :host .button span {\n      text-align: center; }\n  :host .payin {\n    background-color: #ef8200;\n    color: white; }\n  :host .back {\n    left: 0;\n    width: 30%;\n    background-color: #444444;\n    text-align: center; }\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// C:/Program Files (x86)/Jenkins/workspace/tss-keno-web/vit-keno/src/app/punter-bar/payin/payin.component.scss
// module id = ../../../../../src/app/punter-bar/payin/payin.component.scss
// module chunks = 1